module.exports = __webpack_public_path__ + "static/media/progress_schmuck.2e0e4d7b.svg";